import Api from "@/services/Api";

export default {
  fetchDeviceStatus() {
    return Api().get("get-device-status");
  }
};
